/**
 * Generate a random number from 1 to 1000
 */
const generateRandomNumber = () => {
  return Math.floor(Math.random() * 1000) + 1;
};

export { generateRandomNumber };
